<div class="tw-flex tw-justify-end">
  <span class="tw-font-lexend tw-text-100 tw-text-gray-400 tw-leading-none tw-uppercase" i18n="@@reportParameterTargetLabel">Target</span>
</div>
<div class="tw-flex tw-flex-col tw-gap-2 -tw-mt-2">
  @for (parameter of parameters(); track parameter.key) {
    <div class="tw-flex tw-items-end tw-gap-4">
      <div class="tw-flex-1 tw-min-w-0">
        <div class="tw-flex tw-items-center tw-gap-2">
          <span class="tw-font-lexend tw-font-bold tw-text-200 tw-leading-6 tw-text-gray-800">{{ parameter.label }}</span>
          <span class="tw-font-lexend tw-text-100 tw-leading-none tw-text-white tw-rounded-1 tw-px-1 tw-py-0.5"
            [class.tw-bg-green-400]="parameter.isInRange"
            [class.tw-bg-orange-400]="!parameter.isInRange">{{ parameter.patientScore }}</span>
        </div>
        <div class="tw-h-2 tw-rounded-full tw-bg-gray-200 tw-overflow-hidden">
          <div class="tw-h-full tw-rounded-full"
            [style.width.%]="parameter.scorePercentage"
            [class.tw-bg-green-400]="parameter.isInRange"
            [class.tw-bg-orange-400]="!parameter.isInRange"></div>
        </div>
      </div>
      <span class="tw-font-lexend tw-text-100 tw-leading-3 tw-text-gray-800 tw-whitespace-nowrap">{{ formatTargetRange(parameter.targetRange) }}</span>
    </div>
  }
</div>
